import type { Position } from "@kundeninfo/api-client";

/**
 * Texte des Positions-Editors zu Zeilenart und Gliederung (Spec „Überschriften mit Ebene“, Dirk 03./04.11.2026):
 * Schlüssel englisch, Werte deutsch (Hausregel „Texte in Properties“). Die Ebene heisst in der Oberfläche 1–3, im
 * Datenmodell 0–2.
 */
export const POSITION_TEXT = {
  kind: { HEADING: "Überschrift", ITEM: "Position", SUBTOTAL: "Zwischensumme", TEXT: "Textzeile" } as
    Readonly<Record<Position["kind"], string>>,
  /** Der Name einer frisch eingefügten Zeile — ITEM, TEXT und HEADING brauchen einen (sonst Feldfehler). */
  newName: { HEADING: "Neue Überschrift", ITEM: "Neue Position", SUBTOTAL: "Zwischensumme", TEXT: "Text" } as
    Readonly<Record<Position["kind"], string>>,
  level: (level: number) => `Ebene ${level + 1}`,
  levelGroup: "Ebene",
  levelOfRow: (nummer: number) => `Ebene Zeile ${nummer}`,
  indent: (nummer: number) => `Zeile ${nummer} einrücken`,
  outdent: (nummer: number) => `Zeile ${nummer} ausrücken`,
} as const;

/** Die Ebenen einer Überschrift im Datenmodell (Domäne: 0..2). */
export const HEADING_LEVELS = [0, 1, 2] as const;
